import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMinimize45: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"minimize-45, arrow, shrink"} maskId="square-filled-radius-0-stroke-1-IconMinimize45"><path fillRule="evenodd" clipRule="evenodd" d="M21.2072 3.50008L14.7072 10.0001H21.0001V11.0001H13.0001V3.00008H14.0001V9.29297L20.5001 2.79297L21.2072 3.50008ZM3.00008 13.0001H11.0001V21.0001H10.0001V14.7072L3.50008 21.2072L2.79297 20.5001L9.29297 14.0001H3.00008V13.0001Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconMinimize45;
